<template lang="html">
    <div class="common-editor">
        <input type="hidden" v-bind:value="innerValue" />
        <Editor
                v-if="isUpdated"
                :id="editorId"
                :init="init"
                :disabled="disabled"
                v-model="innerValue"
                :placeholder="placeholder"
        ></Editor>
    </div>
</template>

<script>
import tinymce from 'tinymce/tinymce' //tinymce默认hidden，不引入不显示
import Editor from '@tinymce/tinymce-vue'//编辑器引入
import 'tinymce/themes/silver/theme'//编辑器主题
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/media";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/preview";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/hr";
import "tinymce/plugins/paste";
import "tinymce/plugins/codesample";
// import "tinymce/plugins/emoticons"

  export default {
    props: {
        'value': {},
        'disabled': {},
        'editorId': {
            default:'tinymceId'
        },
        'editorHeight': {
            default: 500
        },
        'placeholder': {}
    },
    event: 'change',
    components: {
        Editor
    },
    data() {
        return {
            content:'',
            isUpdated: true,
        };
    },
    computed: {
        innerValue: {
            get() {
               return this.value
            },
            set(val) {
                 this.$emit('input', val) //这里多用于子组件间没有input元素中,通过在computed属性中监听值变化事emit input事件
            }
        },
        init() {
            return {
                selector: '#'+this.editorId,
                language_url: './static/tinymce/zh-Hans.js',//汉化路径是自定义的，一般放在public或static里面
                language: 'zh-Hans',
                height: this.editorHeight,
                skin_url: "./static/tinymce/skins/ui/oxide", //编辑器需要一个skin才能正常工作，所以要设置一个skin_url指向之前复制出来的skin文件
                content_css: './static/tinymce/skins/content/default/content.css',
                content_style: 'body {background: @bgColor;font-family: "Arial", "Helvetica", sans-serif, "SimHei", "Microsoft YaHei";} a,h1,h2,h3 { margin: 0;  padding: 0;}div {  box-sizing: border-box;} a {text-decoration: none;} li {list-style: inherit;}',
                menubar: "", //菜单条
                plugins:
                "placeholder link lists image code table wordcount media table fullscreen preview pagebreak insertdatetime hr paste codesample", //插件
                toolbar:
                "bold italic underline strikethrough  | fontselect | fontsizeselect | formatselect  | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | removeformat| undo redo | link unlink image media insertdatetime table  hr pagebreak codesample", //工具条
                font_formats:
                "Arial=arial,helvetica,sans-serif;宋体=SimSun;微软雅黑=Microsoft Yahei;Impact=impact,chicago;", //字体
                fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px 64px 72px", //文字大小
                branding: false, //水印
                elementpath: false, //底部元素路径
                paste_data_images: true, //允许粘贴图片
                file_picker_types: "media",
                paste_retain_style_properties: "all",
                toolbar_drawer: 'false'
            }
        }
    },
    methods: {
        refresh() {
            this.isUpdated = false;
            this.$nextTick(()=> {
                this.isUpdated = true;
            })
        }
    },
    watch: {
    },
    mounted: function() {
        tinymce.init({});
    }
  };
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// CommonEditor.vue?06232ffb